import { IconButton } from '@hub/common/IconButton/IconButton';
import { IconID } from '@hub/common/Icon/Icon';
import { ToastType, useToasts } from '@hub/hooks/useToasts';
import { useTranslation } from 'next-i18next';
import * as Sentry from '@sentry/nextjs';

export interface CopyToClipboardProps {
  text: string;
  copiedLabel: string;
}

export const CopyToClipboard = ({ text, copiedLabel }: CopyToClipboardProps) => {
  const { addToast } = useToasts();
  const { t } = useTranslation('product/copyToClipboard');
  const copyToClipboard = async (content: string, label: string) => {
    if (!navigator?.clipboard) {
      // IE WORKAROUND
      const el = document.createElement('textarea');
      el.value = content;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      return;
    }
    try {
      await navigator?.clipboard.writeText(content).then(() =>
        addToast({
          content: t('COPY_TO_CLIPBOARD.COPY_SUCCESS', {
            copiedItem: label,
          }),
          type: ToastType.SUCCESS,
        })
      );
    } catch (error) {
      Sentry.captureException(new Error(`Could not copy to clipboard - ${error as string}`));
    }
  };
  return (
    <IconButton
      title={t('COPY_TO_CLIPBOARD.TITLE')}
      icon={IconID.COPY_TO_CLIPBOARD}
      size={5}
      onClick={() => copyToClipboard(text, copiedLabel)}
      primary={false}
      className={{ 'p-3': false, 'p-0': true, 'pl-3': true }}
    />
  );
};
